var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-gap-32"},_vm._l((_vm.items),function(item){return _c('router-link',{key:item.key,staticClass:"directory-breadcrumb",attrs:{"to":{name: item.routeName}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }